import { useParams } from 'react-router-dom'

const useCurrentChatId = () => {
  const { chatId } = useParams<{ chatId: string }>()
  return chatId || null
}

export default useCurrentChatId
